import { render, staticRenderFns } from "./GlDiskSpace.vue?vue&type=template&id=1125b8a4&scoped=true"
import script from "./GlDiskSpace.vue?vue&type=script&lang=js"
export * from "./GlDiskSpace.vue?vue&type=script&lang=js"
import style0 from "./GlDiskSpace.vue?vue&type=style&index=0&id=1125b8a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125b8a4",
  null
  
)

export default component.exports